import { RuleTabs } from '../utils/enums';
import { keyBy } from 'lodash';

export enum ErrorSource {
    UNDEFINED = 'UNDEFINED',
    CUSTOMER_SERVICE = 'CUSTOMER_SERVICE'
}

export enum ErrorType {
    AAD = 'internal',
    HALOB_NO_TRIPLETS = 'external',
    HALOB_NO_ROLES = 'external-no-roles'
}

export enum ErrorCode {
    SPECIFIC_ERR_BAD_REQUEST = 412,
    UNAUTHENTICATED = 401,
    UNAUTHORIZED = 403,
    NOT_FOUND = 404,
    REDIRECT = 301,
    REDIRECT_TO_LOGOUT = 418,
    EXCEED_COUNT = 429
}

export enum UnauthorizedBody {
    NO_MATCHING_TRIPLETS = 'no matching triplets',
    NO_ROLES = 'no roles',
    NO_MATCHING_ROLE = 'no matching role',
    NO_ORGANIZATIONS = 'no organizations',
    NO_ACCOUNT = 'no account',
    NO_UBANS = 'no ubans'
}

export interface ErrorResult {
    errorSource: ErrorSource;
    errorMessage?: string;
    parameters?: string[];
}

export interface FieldMessage {
    fieldName: string;
    isValid: boolean;
    message: string;
    componentLinkDetails?: ComponentLinkDetails;
}

export interface ComponentLinkDetails {
    url: string;
    text: string;
}

export interface TabsErrors {
    [tab: string]: FieldMessage[];
}

export const getErrorsBySection = (errors: TabsErrors, section: RuleTabs) => {
    return keyBy(errors[section], 'fieldName');
};

const hasError = (errorObj: FieldMessage) => {
    return errorObj && !errorObj.isValid;
};

export const getErrorMessage = (errorObj: FieldMessage, message: string) => {
    return hasError(errorObj) ? message : undefined;
};

export const getMandatoryErrorMessage = (errorObj: FieldMessage) => {
    return getErrorMessage(errorObj, 'Required');
};
